import React from "react";
import { Tag } from "antd";
import { $t } from "~/i18n.js";

export const TagIcon = ({ icon = null, color = "default", children, style = {}, ...props }) => {
  return (
    <Tag color={color} style={style} icon={icon} {...props}>
      {children}
    </Tag>
  );
};
